module.exports = "pegasus_template/assets/circle-tumblr.png";